// v4 imports
import React from "react";
import {
    Box,
    Grid,
    Card,
    CardContent,
    CardActions,
    Typography,
    Divider,
    CircularProgress,
} from "@material-ui/core";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import DescriptionIcon from "@material-ui/icons/Description";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";

// Use your existing custom Button so styling stays consistent
import Button from "components/CustomButtons/Button.js";
import { ArrowRight, ArrowRightAlt } from "@material-ui/icons";

// Reusable section
export default function NextStepsSection({
    steps,
    loadingKey, // optional: key of the step that's currently running
    title = "Suggested Next Steps",
}) {
    return (
        <Box component="section" aria-labelledby="next-steps-title" mt={1}>
            <Typography id="next-steps-title" variant="h6" gutterBottom style={{ textTransform: "none" }}>
                {title}
            </Typography>
            <Divider style={{ marginBottom: 16 }} />

            <Grid container spacing={2}>
                {steps.map((s) => (
                    <Grid item xs={12} sm={6} md={4} key={s.key}>
                        <Card variant="outlined" style={{ height: "100%" }}>
                            <CardContent>
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Box
                                        display="inline-flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        style={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: 8,
                                            background: "rgba(0,0,0,0.06)",
                                            marginRight: 12,
                                        }}
                                    >
                                        {s.icon}
                                    </Box>
                                    <Typography variant="body1">{s.title}</Typography>
                                </Box>

                                {s.badge && (
                                    <Typography
                                        variant="caption"
                                        style={{
                                            padding: "2px 6px",
                                            background: "rgba(0,0,0,0.06)",
                                            borderRadius: 6,
                                            marginRight: 8,
                                        }}
                                    >
                                        {s.badge}
                                    </Typography>
                                )}

                                <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                                    {s.description}
                                </Typography>
                                <Button
                                    size="sm"
                                    color="quCreateColor"
                                    style={{ marginTop: 16 }}
                                    onClick={s.onClick}
                                    disabled={loadingKey === s.key}
                                >
                                    {loadingKey === s.key ? (
                                        <>
                                            <CircularProgress size={16} />&nbsp;Working…
                                        </>
                                    ) : (
                                        s.actionLabel || "Start"
                                    )} <ArrowRightAlt style={{ height: 14, marginRight: -5 }} />
                                </Button>
                                {s.secondaryAction && (
                                    <Button size="sm" onClick={s.secondaryAction.onClick}>
                                        {s.secondaryAction.label}
                                    </Button>
                                )}
                            </CardContent>

                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
